/* eslint-disable */
// eslint-disable-next-line object-shorthand
import { client } from "./client";
export const list = params => client.get("partners_payments", { params: params });
export const get = id => client.get(`partners_payments/${id}`);
// eslint-disable-next-line object-shorthand
export const exportPayments = params => client.post("partners_payments/export", params);
export const newPayment = params => client.post("partners_payments", { partnerPayment: params });
export const updateSubscription = params =>
  client.post(`partners_payments/subscription_update/${params["id"]}`, { subscription: params });
